module.exports = __webpack_public_path__ + "img/Porto Apartment - 64 of 85.2eb38342.jpeg";